export default "__VITE_ASSET__KnmK_A85__"